<template>
  <div class="project-advantage">
    <div class="project-advantage-content">
      <div class="content">
        <img src="../productManageImg/num-01.png" alt="" />
        <div class="content-word">
          <h2>项目广度增加</h2>
          <h3>加强行业大局软实力</h3>
          <p>扩大每个项目的内容辐射广度，<br />让你拓展行业认知，构建商业模式，带领战略方向，升高视野界限</p>
        </div>
      </div>
      <div class="content">
        <img src="../productManageImg/num-02.png" alt="" />
        <div class="content-word">
          <h2>项目覆盖增加</h2>
          <h3>保障产品设计硬技能</h3>
          <p>项目使用场景细致，深入理解用户痛点，合理把控产品需求，梳理复杂业务逻辑，搭建产品架构，平衡产品线价值</p>
        </div>
      </div>
      <div class="content">
        <img src="../productManageImg/num-03.png" alt="" />
        <div class="content-word">
          <h2>项目保持市场前排</h2>
          <h3>紧随业务发展迭代</h3>
          <p>产品随领域发展而及时更新，<br />通过分析数据，带动运营、市场需求，教你制定项目迭代策略， 规划产品路径</p>
        </div>
      </div>
      <div class="content">
        <img src="../productManageImg/num-04.png" alt="" />
        <div class="content-word" style="border: none;">
          <h2>产品总监师资团队</h2>
          <h3>倾授大厂实践经验</h3>
          <p>项目内容不止方法论，公司产品总监授课， 讲解公司实地的统筹管理过程</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .project-advantage {
    background-color: #fff;
    margin: 0 auto;
    width: 80%;
    min-width: 1180px;
    max-width: 1340px;
    padding-bottom: 76px;
    .project-advantage-title {
      padding-top: 76px;
      width: 100%;
      text-align: center;
      h1 {
        display: inline-block;
        text-align: center;
        font-size: 36px;
        // font-family: "Fontquan-qingkehuangyouti";
        font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
        font-weight: 400;
        line-height: 45px;
        color: #19232B;
      }
    }
    .project-advantage-content {
      padding-top: 65px;
      display: flex;
      .content {
        padding-bottom: 40px;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 100px;
          height: 100px;
        }
        .content-word {
          margin-top: 48px;
          text-align: center;
          h2 {
            height: 28px;
            font-size: 20px;
            font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
            font-weight: 600;
            color: #19232B;
            line-height: 28px;
          }
          h3 {
            margin-top: 7px;
            height: 22px;
            font-size: 16px;
            font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
            font-weight: 400;
            color: #19232B;
            line-height: 22px;
          }
          p {
            margin-top: 32px;
            width: 225px;
            height: 100px;
            font-size: 14px;
            font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
            font-weight: 400;
            color: #616A72;
            line-height: 24px;
          }
        }
      }
    }
  }
</style>